var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// - Import react components
import { db } from 'data/firestoreClient';
import { SocialError } from 'core/domain/common';
import { injectable } from 'inversify';
/**
 * Firbase comment service
 *
 * @export
 * @class CommentService
 * @implements {ICommentService}
 */
var CommentService = /** @class */ (function () {
    function CommentService() {
        /**
         * Add comment
         *
         * @memberof CommentService
         */
        this.addComment = function (comment) {
            return new Promise(function (resolve, reject) {
                var commentRef = db.collection('comments');
                commentRef.add(comment).then(function (result) {
                    resolve(result.id);
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Get comments
         *
         * @memberof CommentService
         */
        this.getComments = function (postId, next) {
            var commentsRef = db.collection("comments").where('postId', '==', postId);
            var unsubscribe = commentsRef.onSnapshot(function (snapshot) {
                var _a;
                var parsedData = (_a = {}, _a[postId] = {}, _a);
                snapshot.forEach(function (result) {
                    parsedData[postId][result.id] = __assign({ id: result.id }, result.data());
                });
                if (next) {
                    next(parsedData);
                }
            });
            return unsubscribe;
        };
        /**
         * Update comment
         *
         * @memberof CommentService
         */
        this.updateComment = function (comment) {
            return new Promise(function (resolve, reject) {
                var batch = db.batch();
                var commentRef = db.collection("comments").doc(comment.id);
                batch.update(commentRef, __assign({}, comment));
                batch.commit().then(function () {
                    resolve();
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Delete comment
         *
         * @memberof CommentService
         */
        this.deleteComment = function (commentId) {
            return new Promise(function (resolve, reject) {
                var commentCollectionRef = db.collection("comments");
                var commentRef = commentCollectionRef.doc(commentId);
                var batch = db.batch();
                batch.delete(commentRef);
                batch.commit().then(function () {
                    resolve();
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
    }
    CommentService = __decorate([
        injectable()
    ], CommentService);
    return CommentService;
}());
export { CommentService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/comments/CommentService.ts
// module id = 309
// module chunks = 50